"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboChartDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableComboChart_1 = require("./PluggableComboChart");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var ComboChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(ComboChartDescriptor, _super);
    function ComboChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComboChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableComboChart_1.PluggableComboChart(params); };
    };
    return ComboChartDescriptor;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.ComboChartDescriptor = ComboChartDescriptor;
//# sourceMappingURL=ComboChartDescriptor.js.map